<template>
    <div class="container">
        <div class="layout-content">
            <global-header
                :title="'학교 방문예약'"
            />
            <sub-header
                :title="`방문예약할 학교를 선택해주세요.`"
            />
            <div class="content">
                <div
                    class="school-info"
                    v-for="(item, i) in schools" :key="i"
                    @click="handleSchoolSelect(item)"
                >
                    <div class="school-info__logo">
                        <img
                            :src="item.prof_url"
                            title="학교로고"
                        />
                    </div>
                    <div class="school-info__name" v-html="item.name">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalHeader from "@/components/common/GlobalHeader.vue";
import SubHeader from "@/components/common/SubHeader.vue";
import { store } from "@/store";
import api from "@/api";

export default {
    name: "AppSelectSchool",
    components: { SubHeader, GlobalHeader },
    data: () => ({
        store,
        schools: null,
    }),
    methods: {
        async getSchools(token) {
            let params = {
                token: token
            };
            let result = await api.getAppSchoolList(params);
            this.schools = result.schools;
            store.auth = {
                type: "APP_USER",
                token: token,
            }
            store.visitor = {
                name: result.name,
                phone: result.phone,
            }
        },
        async handleSchoolSelect(item) {

            store.school = {
                id: item.school_id,
                name: item.name,
                prof_url: item.prof_url,
            }

            // api 학교정보 조회
            const data = await api.getSchoolInfo(item.school_id);

            if(data.available === 0) {
                this.$router.push({ path: `/schools/${store.school.id}/unused` });
            }

            this.store.available = data.available;
            this.store.available_time = data.available_time;
            this.store.classrooms = data.classrooms;
            this.store.exclusion_date = data.exclusion_date;

            this.$router.push({ path: `/schools/${store.school.id}/visit/app/personal` });
        }
    },
    mounted() {
        this.getSchools(this.$route.query.token);
        // if(this.schools.length === 1) {
        //     handleSchoolSelect(this.schools[0].school_id);
        // }
    }
};
</script>

<style lang="scss" src="../../styles/_reservation.scss"></style>
